import React from 'react';

/**
 * Case RGPD réutilisable.
 * Props:
 *  - checked: bool
 *  - onChange: fn(bool)
 *  - companyName: string | null  → si absent, texte générique
 */
export default function RgpdCheckbox({ checked, onChange, companyName }) {
  const text = companyName
    ? `J'accepte que mes informations soient traitées par ${companyName} pour le suivi de ma demande.`
    : `J'accepte que mes informations soient traitées pour le suivi de ma demande.`;

  return (
    <div className="flex items-start gap-2 mt-3">
      <input
        type="checkbox"
        id="rgpd-consent"
        checked={checked}
        onChange={e => onChange(e.target.checked)}
        className="mt-0.5 h-4 w-4 rounded border-gray-300 accent-blue-600 cursor-pointer shrink-0"
        data-testid="rgpd-consent-checkbox"
      />
      <label htmlFor="rgpd-consent" className="text-xs text-gray-500 leading-relaxed cursor-pointer select-none">
        {text}{' '}
        <span className="text-gray-400 italic">(obligatoire)</span>
      </label>
    </div>
  );
}
